import { memo, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { useStores } from 'stores/utils/hooks/useStores'
import Typography from '@material-ui/core/Typography'

const Backlink = () => {
  const {
    page: { isFirstDisplayedPage, getFirstDisplayedPageName },
    navigation: { currentPageInSession }
  } = useStores()

  const firstPageUrl = useMemo(() => {
    if (isFirstDisplayedPage(currentPageInSession)) {
      return null
    }

    return getFirstDisplayedPageName()
  }, [currentPageInSession, getFirstDisplayedPageName, isFirstDisplayedPage])

  if (!firstPageUrl) {
    return null
  }

  return (
    <Typography>
      Wenn Sie Ihre bisherigen Eingaben noch einmal prüfen wollen, klicken Sie{' '}
      <Link to={firstPageUrl}>hier</Link>.
    </Typography>
  )
}

export default memo(Backlink)
